import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { withStyles } from '@material-ui/core/styles'
import { SvgIcon } from '@material-ui/core'
import { mdiCancel, mdiCheck } from '@mdi/js'

class StatusEnabledDisabled extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    className: PropTypes.string,
    enabled: PropTypes.bool.isRequired,
    showText: PropTypes.bool,
  }

  static defaultProps = {
    className: null,
    showText: false,
  }

  static styles = () => ({
    status: {},
    icon: {
      marginLeft: 4,
      verticalAlign: 'middle',
    },
  })

  render() {
    const { classes, className, enabled } = this.props
    const clNames = classNames(className, classes.status)

    if (enabled) {
      return (
        <span className={clNames}>
          { this.props.showText && 'Enabled' }
          <SvgIcon className={classes.icon}>
            <path d={mdiCheck} />
          </SvgIcon>
        </span>
      )
    }

    return (
      <span className={clNames}>
        { this.props.showText && 'Disabled' }
        <SvgIcon className={classes.icon}>
          <path d={mdiCancel} />
        </SvgIcon>
      </span>
    )
  }
}

export default withStyles(StatusEnabledDisabled.styles)(StatusEnabledDisabled)
